<script>
  import relatorioTecnicoProjetoServico from '../servico';
  import PlanoTrabalho from './compartilhado/FormPlanoTrabalho.vue';

  export default {
    components: { PlanoTrabalho },
    data() {
      return {
        mostrarFormulario: false,
        planoTrabalhos: [],
        pendencia: "",
        aprovado: false,
        carregando: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Plano de Trabalho - Editar #' + this.$route.params.numeroRelatorio;
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-plano-trabalho"]').tab('show');
            }

            return valido;
          })
          .then(this.validaValores)
          .then(this.enviar)
          .then(() => this.$router.push({ name: 'relatorio-tecnico-projeto' }))
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar plano de trabalho do projeto.');
          });
      },
      validaValores(valido) {
        if (!valido) throw new Error("validacao com erro");

        var validado = true;

        for (let i = 0; i < this.planoTrabalhos.length; i = i + 1) {
          let valor = this.$options.filters.formatarNumero(this.planoTrabalhos[i].quantidadeExecutada, true);

          if ((valor < 0.01) && (!this.planoTrabalhos[i].observacao)) {
            validado = false
            break
          }
        }

        if (validado)
          return true;

        this.$swal(
          '',
          '&Eacute; necess&aacute;rio informar uma quantidade executada ou preencher o campo de observa&ccedil;&atilde;o dos planos de trabalho n&atilde;o executados.',
          'info'
        );

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaPlanoTrabalho = JSON.parse(JSON.stringify(this.planoTrabalhos));

        return relatorioTecnicoProjetoServico.alterarPlanoTrabalho(copiaPlanoTrabalho, this.$route.params.id);
      },
      carregar(id) {
        this.carregando = true;

        let planoTrabalhos = null;
        let pendencia = "";
        let aprovado = null;

        relatorioTecnicoProjetoServico
          .obterPlanoTrabalho(id)
          .then(dados => {
            pendencia = dados.pendencia;
            planoTrabalhos = dados.planoTrabalhos;
            aprovado = dados.aprovado;
          })
          .then(() => {
            this.$set(this, 'planoTrabalhos', planoTrabalhos);
            this.$set(this, 'pendencia', pendencia);
            this.$set(this, 'aprovado', aprovado);

            this.carregando = false;
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-plano-trabalho">
                  Plano Trabalho
                </a>
              </li>

              <li v-if="pendencia !== ''">
                <a data-toggle="tab"
                   href="#tab-pendencia">
                  Pend&ecirc;ncias
                </a>
              </li>
            </ul>

            <div class="tab-content">

              <div id="tab-plano-trabalho" class="tab-pane active">
                <div class="panel-body">
                  <plano-trabalho ref="planoTrabalho"
                                  :planotrabalhos="planoTrabalhos"
                                  :aprovado="aprovado"
                                  :edicao="!!$route.params.id"
                                  :readonly="!!$route.params.idResponsavelEnvio">
                  </plano-trabalho>
                </div>
              </div>

              <div id="tab-pendencia" class="tab-pane">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="form-group">
                        <textarea class="form-control" style="height: 700px;"
                                  id="pendencia"
                                  data-vv-name="pendencia"
                                  v-model="pendencia"
                                  readonly="readonly">
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
     
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">    
            <router-link class="btn btn-default"
                         :to="{ name: 'relatorio-tecnico-projeto' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button 
                type="button" 
                class="btn btn-default" 
                @click="resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="!$route.params.idResponsavelEnvio"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/FormPlanoTrabalhoForm.vue